'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _slicedToArray = _interopDefault(require('babel-runtime/helpers/slicedToArray'));
var _Object$entries = _interopDefault(require('babel-runtime/core-js/object/entries'));
var _getIterator = _interopDefault(require('babel-runtime/core-js/get-iterator'));
var _typeof = _interopDefault(require('babel-runtime/helpers/typeof'));
var _Object$assign = _interopDefault(require('babel-runtime/core-js/object/assign'));
var _classCallCheck = _interopDefault(require('babel-runtime/helpers/classCallCheck'));
var _createClass = _interopDefault(require('babel-runtime/helpers/createClass'));

/**
 * Css Classify (https://kennyhyun.github.io/npm-css-classify)
 *
 * Copyright © 2017 Kenny Kyunghyun Yeo. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

var Classify = function () {
  function Classify() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        block = _ref.block,
        options = _ref.options;

    _classCallCheck(this, Classify);

    this.block = block;

    var _ref2 = options || {},
        _ref2$elementDelimite = _ref2.elementDelimiter,
        elementDelimiter = _ref2$elementDelimite === undefined ? '__' : _ref2$elementDelimite,
        _ref2$modifierDelimit = _ref2.modifierDelimiter,
        modifierDelimiter = _ref2$modifierDelimit === undefined ? '--' : _ref2$modifierDelimit;

    _Object$assign(this, {
      elementDelimiter: elementDelimiter,
      modifierDelimiter: modifierDelimiter
    });
  }

  _createClass(Classify, [{
    key: '_getCombindElement',
    value: function _getCombindElement() {
      var block = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var elem = '';
      if (block && element) {
        elem = '' + block + this.elementDelimiter + element;
      } else {
        elem = '' + block + element;
      }
      return elem;
    }
  }, {
    key: 'bem',
    value: function bem(block) {
      var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var elem = this._getCombindElement(block, element);
      return this.names(elem, modifiers, '');
    }
  }, {
    key: 'names',
    value: function names(_element) {
      var _this = this;

      var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var _block = arguments[2];

      var block = this.block;
      if (typeof _block === 'string' || _block) {
        block = _block;
      }
      var element = this._getCombindElement(block, _element);
      if (!modifiers) {
        return element;
      }
      if (typeof modifiers === 'string') {
        return element + ' ' + element + this.modifierDelimiter + modifiers;
      } else if (Array.isArray(modifiers)) {
        var array = modifiers.map(function (m) {
          return '' + element + _this.modifierDelimiter + m;
        });
        return ['' + element].concat(array).join(' ');
      } else if ((typeof modifiers === 'undefined' ? 'undefined' : _typeof(modifiers)) === 'object') {
        var _array = [];
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = _getIterator(_Object$entries(modifiers)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _step$value = _slicedToArray(_step.value, 2),
                key = _step$value[0],
                val = _step$value[1];

            var judge = val;
            if (typeof val === 'function') {
              judge = val();
            }
            if (judge) {
              _array.push('' + element + this.modifierDelimiter + key);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        return ['' + element].concat(_array).join(' ');
      }
      return element + ' ' + element + this.modifierDelimiter;
    }
  }]);

  return Classify;
}();

function newBlock(block) {
  return new Classify({ block: block });
}
var CssClassify$1 = Classify;

exports['default'] = Classify;
exports.newBlock = newBlock;
exports.CssClassify = CssClassify$1;
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./~/css-classify/dist/index.js
// module id = 431
// module chunks = 0